import { isImmutableRecord } from 'app/common/utils/immutable-type-util';
import { type ChangeEvent, type ChangeEventHandler, useCallback } from 'react';
import type { WidgetProps } from '../../../types.js';
import { getWidgetId, useWidgetTitle } from '../../../util/widget.js';

export type BooleanWidgetHookProps = {
  label: string;
  checked: boolean;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  description?: string;
  id: string;
} & WidgetProps;

export const useBooleanWidget = (props: WidgetProps) => {
  const { schema, value, onChange, onBlur } = props;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked);
      onBlur();
    },
    [onBlur, onChange]
  );

  const label = useWidgetTitle(props);
  const id = getWidgetId(props);

  const rawValue = isImmutableRecord(value) ? value.toJS() : value === '' ? undefined : value;
  const checked = rawValue === undefined ? Boolean(schema.get('default')) : Boolean(rawValue);

  return {
    ...props,
    label,
    checked,
    handleChange,
    description: schema.get('description'),
    id
  };
};
